import { Office } from '../lib/types';

export const offices: Office[] = [
  {
    id: '1',
    name: 'Douala',
    address: 'BP 2606 Boulevard de la République',
    city: 'Douala',
    country: 'Cameroon',
    coordinates: {
      lat: 4.0511,
      lng: 9.7679,
    },
    phone: '+237 698 835 251',
    email: 'pngatcha@excimaa.ca',
    services: ['Audit & Assurance', 'Tax Consulting', 'Business Advisory'],
    image: '/images/Cities/Douala.jpg',
    googleMapsUrl: 'https://maps.app.goo.gl/ayEVREEvn4EeQqE19',
  },
  {
    id: '2',
    name: 'Toronto',
    address: '1395 Marshall Crescent, Milton, ON L9T 6N4',
    city: 'Toronto',
    country: 'Canada',
    coordinates: {
      lat: 43.5282,
      lng: -79.8421,
    },
    phone: '+1 416 624 2510',
    email: 'pkemeni@excimaa.ca',
    services: ['International Tax', 'Immigration Services', 'Financial Planning'],
    image: '/images/Cities/Canada.jpg',
    googleMapsUrl: 'https://maps.app.goo.gl/gdGN6NoTTDSYcjed9',
  },
  {
    id: '3',
    name: 'Kigali',
    address: 'KG 5 Avenue, Kigali',
    city: 'Kigali',
    country: 'Rwanda',
    coordinates: {
      lat: -1.9441,
      lng: 30.0619,
    },
    phone: '+250 787 779 965',
    email: 'mnkwain@excimaa.ca',
    services: ['Financial Advisory', 'Risk Management', 'Audit Services'],
    image: '/images/Cities/rwanda.jpg',
    googleMapsUrl: 'https://maps.app.goo.gl/CJXVnrwwJtq1fBbN8',
  },
  {
    id: '4',
    name: 'Washington DC',
    address: '300 K St NW',
    city: 'Washington DC',
    country: 'United States',
    coordinates: {
      lat: 38.9072,
      lng: -77.0369,
    },
    phone: '+1 502 299 247',
    email: 'mnkwain@excimaa.ca',
    services: ['Government Relations', 'Compliance', 'International Tax'],
    image: '/images/Cities/USA-washington.jpeg',
    googleMapsUrl: 'https://maps.app.goo.gl/3Le4R6CA4wJCfCkz6',
  },
  {
    id: '5',
    name: 'Paris',
    address: '5 Square du N',
    city: 'Paris',
    country: 'France',
    coordinates: {
      lat: 48.9861,
      lng: 2.4494,
    },
    phone: '+33 652 452 1402',
    email: 'pkemeni@excimaa.ca',
    services: ['European Accounting', 'EU Compliance', 'Cross-border Consulting'],
    image: '/images/Cities/France-paris.jpg',
    googleMapsUrl: 'https://maps.app.goo.gl/m8EMdBrLxP9QtRS77',
  },
  {
    id: '6',
    name: 'Bujumbura',
    address: 'Boulevard Melchior Ndadaye',
    city: 'Bujumbura',
    country: 'Burundi',
    coordinates: {
      lat: -3.3761,
      lng: 29.3599,
    },
    phone: '+257 793 439 93',
    email: 'mnkwain@excimaa.ca',
    services: ['Local Accounting', 'Business Development', 'Regional Consulting'],
    image: '/images/Cities/Burundi.jpeg',
    googleMapsUrl: 'https://maps.app.goo.gl/4KgUHHsUKw1F6Xwg7',
  },
  {
    id: '7',
    name: 'Pointe-Noire',
    address: 'Ave Colonel Mondjiba',
    city: 'Pointe-Noire',
    country: 'Republic of Congo',
    coordinates: {
      lat: -4.7692,
      lng: 11.8636,
    },
    phone: '+242 06 900 0000',
    email: 'mnkwain@excimaa.ca',
    services: ['Audit Services', 'Tax Advisory', 'Business Consulting'],
    image: '/images/Cities/Pointe-Noire.jpg',
    googleMapsUrl: 'https://maps.app.goo.gl/jbSugb9b3gS4bgdz5',
  },
  {
    id: '8',
    name: 'Libreville',
    address: 'Bd Triomphal',
    city: 'Libreville',
    country: 'Gabon',
    coordinates: {
      lat: 0.4162,
      lng: 9.4673,
    },
    phone: '+241 11 76 82 23',
    email: 'mnkwain@excimaa.ca',
    services: ['Financial Audit', 'Tax Compliance', 'Corporate Advisory'],
    image: '/images/Cities/Libreville-1.jpg',
    googleMapsUrl: 'https://maps.app.goo.gl/PE5zPXeQbDoeqWH67',
  },
  {
    id: '9',
    name: 'Dubai',
    address: 'Business Bay',
    city: 'Dubai',
    country: 'United Arab Emirates',
    coordinates: {
      lat: 25.1972,
      lng: 55.2744,
    },
    phone: '+971 50 123 4567',
    email: 'mnkwain@excimaa.ca',
    services: ['International Business Setup', 'Tax Planning', 'Financial Planning'],
    image: '/images/Cities/Dubai.jpg',
    googleMapsUrl: 'https://maps.app.goo.gl/SUirHFpRKk4mMLbP8',
  },
  {
    id: '10',
    name: 'Kampala',
    address: 'Plot 3, Portal Avenue',
    city: 'Kampala',
    country: 'Uganda',
    coordinates: {
      lat: 0.3136,
      lng: 32.5811,
    },
    phone: '+256 700 000 000',
    email: 'mnkwain@excimaa.ca',
    services: ['Audit & Assurance', 'Tax Compliance', 'Payroll & HR Compliance'],
    image: '/images/Cities/Kampala.jpg',
    googleMapsUrl: 'https://maps.app.goo.gl/kampala',
  },
  {
    id: '11',
    name: 'Dar es Salaam',
    address: 'Ohio Street, CBD',
    city: 'Dar es Salaam',
    country: 'Tanzania',
    coordinates: {
      lat: -6.7924,
      lng: 39.2083,
    },
    phone: '+255 700 000 000',
    email: 'mnkwain@excimaa.ca',
    services: ['Audit & Assurance', 'Accounting & Outsourcing', 'Advisory'],
    image: '/images/Cities/Dar-es-Salaam.jpg',
    googleMapsUrl: 'https://maps.app.goo.gl/daressalaam',
  },
];